/**
 * ArTableClipboardContext
 *
 * Publishes the ONE `useArTableClipboard` instance `ArTableProvider` builds.
 * Consumers: `ArTableBody` (the body div's native copy/paste handlers and ⌘⇧C),
 * `ArRowActions`, `ArRowContextMenu` and `ArBulkActionsMenu`. Every row mounts
 * two of those menus, so instantiating the hook per menu built 2N identical
 * instances on an N-row page (SYD-2314).
 *
 * `null` outside an `ArTableProvider`; consumers assert non-null, matching
 * `ArTableActionsContext`.
 */

import { createContext } from 'react';
import type { UseArTableClipboardReturn } from '../clipboard/useArTableClipboard';

export type ArTableClipboardContextValue = UseArTableClipboardReturn;

export const ArTableClipboardContext = createContext<ArTableClipboardContextValue | null>(
  null
);
